import {internalApi} from "../../../common/axios";
import {useMutationBase, useQueryBase} from "../../../shared/hooks/useHookBase";
import toast from "react-hot-toast";

const fetchPopup = async () => {
    const {data} = await internalApi.get(`popup`);
    return data.rows;
}

export const usePopupData = () => {
    return useQueryBase('popup', fetchPopup, {staleTime: 0});
}

const savePopup = async (data) => {
    try {
        const res = await internalApi.post('popup', {data});
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("저장 실패");
    }
}

export const useSavePopup = () => {
    return useMutationBase('popup', savePopup);
}

const deletePopup = async (popupId) => {
    try {
        const res = await internalApi.delete(`popup/${popupId}`);
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("삭제 실패");
    }
}

export const useDeletePopup = () => {
    return useMutationBase('popup', deletePopup);
}